import React from 'react';
import { useSettings } from '../../contexts/SettingsContext.tsx';

interface AuthCardProps {
  title: string;
  subtitle?: React.ReactNode;
  stepChip?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  error?: React.ReactNode;
}

const AuthCard: React.FC<AuthCardProps> = ({
  title,
  subtitle,
  stepChip,
  children,
  footer,
  error,
}) => {
  const { settings } = useSettings();
  const brandName = settings?.companyName || 'Meu Patrimônio';
  const brandMark =
    brandName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(w => w[0])
      .join('')
      .toUpperCase() || 'MP';

  return (
    <div className="auth-page">
      <div className="auth-wrap">
        <div className="auth-brand">
          <div className="brand-mark">{brandMark}</div>
          <div className="auth-brand-name">{brandName}</div>
          <div className="auth-brand-sub">acesso seguro</div>
        </div>
        <div className="auth-card">
          <div className="auth-card-body">
            {stepChip && (
              <div className="auth-step-chip">
                <span className="dot" /> {stepChip}
              </div>
            )}
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
            {error}
            {children}
          </div>
          {footer && <div className="auth-card-footer">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AuthCard;
